import React from "react";
import BrandImg from "../../assets/login/logo.svg";
import "./BrandLogoEnd.css";
const BrandLogoEnd = () => {
  return (
    <div className="brand-logo-end">
      <img src={BrandImg} alt="LandBook" />
    </div>
  );
};

export default BrandLogoEnd;
